import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import PageContainer from '@/components/Container/PageContainer';
import ContractNew from '@/components/DealList/ContractNew';

export default function SignatureV2WorkflowPage() {
  // @ts-ignore i18next's deeply nested translation key type exceeds CRA's incremental compiler limit.
  const { t } = useTranslation();
  const { workflowId = '' } = useParams();

  return (
    <PageContainer title={t('signatureV2.title')}>
      <ContractNew workflowId={workflowId} />
    </PageContainer>
  );
}
